"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHitDamage = void 0;
const getStats_1 = require("./getStats");
const typeRelations_1 = require("./typeRelations");
const getHitDamage = (attacker, defender, creatures) => {
    const attackerStats = (0, getStats_1.getStats)(attacker, creatures);
    const defenderStats = (0, getStats_1.getStats)(defender, creatures);
    const attackBonus = (0, typeRelations_1.getTypeAttackBonus)(attacker.traits, defender.traits);
    return Math.ceil((attackerStats.attack / defenderStats.defense) * attackBonus * 4);
};
exports.getHitDamage = getHitDamage;
